/**
 * @generated SignedSource<<6618727869e83c51134b946cb67b705d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NavigationItemTab_container$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AppTab_container" | "DefaultTab_container" | "ShortcutsTab_container">;
  readonly " $fragmentType": "NavigationItemTab_container";
};
export type NavigationItemTab_container$key = {
  readonly " $data"?: NavigationItemTab_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationItemTab_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NavigationItemTab_container",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "DefaultTab_container"
    },
    {
      "kind": "FragmentSpread",
      "name": "ShortcutsTab_container"
    },
    {
      "kind": "FragmentSpread",
      "name": "AppTab_container"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "9e2c189c40e4bc3dcbb1cf10c08a8bf2";

export default node;
